type PersonalDetails = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
};

export type TripType = "roundtrip" | "one way";

export type LeadSubmission = PersonalDetails & (
  | { kind: "contact"; message: string }
  | ({
      kind: "quote";
      partySize: string;
      pickupAddress: string;
      destinationAddress: string;
      pickupDate: string;
      pickupTime: string;
    } & (
      | { tripType: "one way" }
      | { tripType: "roundtrip"; returnDate: string; returnTime: string }
    ))
);

export const UNCONFIRMED_SUBMISSION_MESSAGE =
  "We couldn't confirm your submission. Please call (888) 612-1308 before trying again.";

export async function submitLead(submission: LeadSubmission, captchaToken: string) {
  let response: Response;
  try {
    response = await fetch("/api/leads", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...submission, captchaToken }),
    });
  } catch {
    // Retrying an ambiguous Web-to-Lead request can create a duplicate lead.
    throw new Error(UNCONFIRMED_SUBMISSION_MESSAGE);
  }

  const result = await response.json().catch(() => null);
  if (!response.ok || result?.status !== "submitted") {
    throw new Error(
      typeof result?.message === "string" ? result.message : UNCONFIRMED_SUBMISSION_MESSAGE
    );
  }
}

export type AddressComponent = {
  long_name: string;
  short_name: string;
  types: string[];
};

export function formatQuoteAddress(components: AddressComponent[]) {
  const part = (type: string, short = false) => {
    const component = components.find((item) => item.types.includes(type));
    return (short ? component?.short_name : component?.long_name) || "";
  };
  const street = [part("street_number"), part("route")].filter(Boolean).join(" ");
  const city = part("locality") || part("sublocality_level_1") || part("sublocality") ||
    part("administrative_area_level_2");
  return [street, city, part("administrative_area_level_1", true), part("postal_code")]
    .filter(Boolean).join(", ");
}
